export const API_ENDPOINTS = {
  COMPANY: 'company',
  DASHBOARD: 'dashboard',
  CATEGORIES: 'categories',
  PROFILE_UPDATE: 'profile-update',
  LOGOUT: 'logout',
  ME: 'me',
  TOKEN: 'token',
  UNBLOCK_USER: 'users/unblock-user',
  CHANGE_PASSWORD: 'change_password',
  SCREENS: 'screens',
  SECTORS: 'sectors',
  IPOS:'ipos',
  INDICES:'indices',
  FOLLOW_STOCK:'saveFollowed',
  FORUM:'forum',
  SMEMARKET:'smemarket',
  SUPERINVESTORS:'get_superinvestor',
  ALLCOMAPNIES:'get_all_companies',
  SAVEDEMOPORTFOLIO:'saveDemoPortfolio',
  GETALLDEMOPORTFOLIO:'get_all_demoportfolio',
  GETDEMOPORTFOLIOSINGLE:'get_demoportfolio_single',
};
